import { WishlistRepo } from "../../utils/typescript/repositories/wishlist.repo.ts";
import { map, tap } from "rxjs";
import { rewriteUrlToSoftloginIfNotCart } from "../../utils/typescript/helpers.ts";

const wishlistDialogTriggers = document.querySelectorAll(
  "[data-save-cart-user]",
);
const wishlistDialog: HTMLDialogElement | null = document.querySelector(
  "dialog#dialog-save-cart-user",
);
const wishlistSaveButton: HTMLButtonElement | null = document.querySelector(
  "button[data-save-cart-user-confirm]",
);

const newWishlistNameCallback = (wishlistNameElement: HTMLElement) => {
  WishlistRepo.getNewWishlistName()
    .pipe(tap(() => (wishlistNameElement.textContent = "resolving ...")))
    .subscribe(
      (newWishlist) => (wishlistNameElement.textContent = newWishlist.name),
    );
};

// Get new wishlist name when opening dialog and save wishlist on save button click
wishlistDialogTriggers.forEach((dialogTrigger) => {
  const wishlistNameElement: HTMLElement | null | undefined =
    wishlistDialog?.querySelector("[data-wishlist-name]");
  if (!wishlistNameElement || !wishlistDialog || !wishlistSaveButton) return;

  dialogTrigger.addEventListener("click", () =>
    newWishlistNameCallback(wishlistNameElement),
  );
  wishlistSaveButton.addEventListener("click", () =>
    WishlistRepo.saveNewWishlist()
      .pipe(map(rewriteUrlToSoftloginIfNotCart))
      .subscribe((url) => window.location.replace(url)),
  );
});
